import { Dispatch, SetStateAction } from 'react';

function useFilter(
  state: string,
  setState: Dispatch<SetStateAction<string>>,
  storageItem: string,
  filterArgs: string[]
) {
  const setStorage = (filterArg: string) => {
    setState(filterArg);
    localStorage.setItem(storageItem, filterArg);
  };

  const dropdownActions = filterArgs.map((filterArg: string) => ({
    name: filterArg,
    action: () => setStorage(filterArg),
    disabled: state === filterArg,
  }));

  return dropdownActions;
}

export default useFilter;
